import { DataSources, DataSourceWithGenerics, FiltersPagingAndQuery, RawSearchResult } from "./base.source.details";

type MockDataSourceConfig<Filters, Paging, Query, DevModeResult, Results> = {
    queryResult: FiltersPagingAndQuery<Filters, Paging, Query>;
    searchResult: DevModeResult;
    finalResults: RawSearchResult<Paging, Results>;
};

export function createMockDataSource<Filters, Paging, Query, DevModeResult, Results>(
    type: string,
    config: MockDataSourceConfig<Filters, Paging, Query, DevModeResult, Results>,
): DataSourceWithGenerics<Filters, Paging, Query, DevModeResult, Results> {
    return {
        plugin: "datasource",
        type,
        query: jest.fn().mockReturnValue(config.queryResult),
        search: jest.fn().mockResolvedValue(config.searchResult),
        results: jest.fn().mockReturnValue(config.finalResults),
    };
}

export function createMockDataSources<Filters, Paging, Query, DevModeResult, Results>(
    sources: Record<string, MockDataSourceConfig<Filters, Paging, Query, DevModeResult, Results>>,
): DataSources<Filters> {
    const dataSources: DataSources<Filters> = {};
    for (const [type, config] of Object.entries(sources)) {
        dataSources[type] = createMockDataSource(type, config);
    }
    return dataSources;
}
